import React, { useState, useEffect } from "react";
import Container from "react-bootstrap/esm/Container";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
//import Stack from "react-bootstrap/Stack";
import useUser from "../../hooks/useUser";
//import { CgDanger } from "react-icons/cg";
import Spinner from "react-bootstrap/Spinner";
//import { newUserByFormAptosVetex } from "../../../../../api/apiNewUser";
import "./PreferenceExpress.css";
import ErrorTooltip from "../Home/MyForm/DataClient/ErrorTooltip";
import { getDataClientByEmailInDB,getDataCLMFClientVtexByEmail,getFindClientAptosByEmail,newUserByFormAptosVetex } from "../../api/apiNewUser";
import { useNavigate } from "react-router";

const PreferenceExpress = ({setIsRegistering}) => {
  const [dataUser,
    setDataUser,
    adminUser,
    setAdminUser,
    initialDataUser,
    dataLocalStorage,
    setDataLocalStorage] = useUser();
  const { email, cuponType, nameUser, materno, paterno } = dataUser;
  
  const [showSpinner, setShowSpinner] = useState(false);
  const [registerComplete, setRegisterComplete] = useState(false);
  const [hideSendRegisterButton, setHideSendRegisterButton] = useState(true);
  const [sendingDataUser, setSendingDataUser] = useState(false);
  
  

  
  //const [continuar, setContinuar] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (
      dataLocalStorage.email !== "" &&
      dataLocalStorage.email !== undefined &&
      dataLocalStorage.email !== null &&
      dataLocalStorage.email !== "default"&&
      dataLocalStorage.email !== false&&
      dataLocalStorage.email !== true
    ) {
      navigate("/retry_express");
    }
  }, [dataLocalStorage]);
  useEffect(() => {
    setDataUser({
      ...dataUser,
      registerDomain: "internal",
      registerType: "express",
    });
  }, []);

  useEffect(()=>{
    if(dataUser.isValidFenac&&dataUser.userFenac&&dataUser.fenacUser===''){
      setDataUser({
        ...dataUser,
        fenacUser:dataUser.userFenac.toISOString()
      });
    }else if(!dataUser.isValidFenac&&dataUser.userFenac&&dataUser.fenacUser!=='') {
      setDataUser({
        ...dataUser,
        fenacUser:''
      });
    }

  },[dataUser.isValidFenac,dataUser.userFenac,dataUser.fenacUser])

  useEffect(() => {
    //console.log("dataRegister was updated...", dataUser.dataRegister);
    
    if (
      
      dataUser.cuponType &&
      dataUser.isValidEmail &&
      dataUser.isValidPaterno &&
      dataUser.isValidNameUser 
      
    ) {
      setHideSendRegisterButton(false);
      
      
    } else {
      setHideSendRegisterButton(true);
    }
    if (showSpinner) {
      setHideSendRegisterButton(true);
    }
    if (dataUser.succedRegister) console.log('succedRegister:..true');
    if (registerComplete) {
      
      console.log("Registro Completo:...");
      
    }
    

    return;
  }, [registerComplete, showSpinner, dataUser, dataUser.succedRegister, dataUser.isValidMaterno, dataUser.isValidNameUser, dataUser.isValidPaterno]);

  /* useEffect(()=>{
    if(dataUser.dataID){
      const {idAptos,idCL,idMF}=dataUser.dataID;
      if(idAptos&&idCL&&idMF){
        console.log('Usuario ya esta completamente registrado:...')
        setDataUser({
          ...dataUser,
          userExist:true
        })
        setSendingDataUser(false);
      }
      if(idAptos===null||idCL===null||idMF===null){
        if(sendingDataUser){
          console.log('Usuario puede continuar con su registro:...')
          console.log('idAptos:..',idAptos);
          console.log('idCL:..',idCL);
          console.log('idMF:..',idMF);
          sendDataForm();
        }
        
      }

    }

  },[dataUser?.dataID?.idAptos,dataUser?.dataID?.idCL,dataUser?.dataID?.idMF]) */

  
  const handleChange = (e) => {
    setDataUser({
      ...dataUser,
      [e.target.name]: e.target.value,
    });
  };
  

    //console.log(`${e.target.name}::${e.target.checked}`);
  

  const searchForEmail = async () => {
    
    setSendingDataUser(true);
    setIsRegistering(true);
    //console.log(confirmEmail.email);
    if (!dataUser.isValidEmail) return; //si el email no es un formato valido no te deja avanzar

    try {
      if (dataUser.isValidEmail) {
        //Buscaremos el Cliente en la DB
        const resGetDataClientByEmailInDB = await getDataClientByEmailInDB(
          dataUser.email
        );
        console.log(
          "resGetDataClientByEmailInDB:..",
          resGetDataClientByEmailInDB
        );

        //Aqui comienza la busqueda del email en Aptos y Vtex

        let tempObj = {};
        //Checamos si el correo ya existe en Aptos
        console.log("Checando si el email ya existe en Aptos...");
        const resFindUserinAptos = await getFindClientAptosByEmail(
          dataUser.email
        );
        console.log("idAptos:...", resFindUserinAptos?.data?.dataResAptos);
        if (
          resFindUserinAptos?.data?.duplicityAptos &&
          resFindUserinAptos?.data?.dataResAptos !== ""
        ) {
          //el usuario ya existe en aptos
          tempObj = {
            idAptos: resFindUserinAptos?.data?.dataResAptos,
          };
          //setSendingMail(false);
        }
        if(!tempObj.idAptos){
          tempObj = {
            idAptos: null,
          };
        }

        if (resFindUserinAptos?.data?.msg?.includes("Error" || "error")) {
          //Error en aptos
          setDataUser({
            ...dataUser,
            errorAptos: resFindUserinAptos.data.msg,
          });
          tempObj = {
            ...tempObj,
            errorAptos: resFindUserinAptos.data.msg,
          };
          return
          //setSendingMail(false);
        }

        //Ahora checaremos si el correo ya existe en VTEX
        console.log("Checando si el email ya existe en VTEX...");
        const searchingEmail = await getDataCLMFClientVtexByEmail(
          dataUser.email
        );
        console.log("Response VTEX:..", searchingEmail);

        //if(!tempObj.idAptos&&!tempObj.errorAptos&&searchingEmail.data.dataCL[0]) updateDataUserInFrontend(searchingEmail.data);

        if (searchingEmail?.data?.errorVtex) {
          console.log("Error...", searchingEmail?.data?.message);
          setDataUser({
            ...dataUser,
            errorVtex: true,
          });
        }

        if (
          searchingEmail &&
          searchingEmail?.data &&
          searchingEmail?.data?.dataCL[0] !== undefined
        ) {
          console.log('idCLVtex:..',searchingEmail?.data?.dataCL[0]?.id);
          tempObj = {
            ...tempObj,
            idCL: searchingEmail?.data?.dataCL[0]?.id,
          };
        }
        
        if(!tempObj.idCL||tempObj.idCL===undefined){
          tempObj = {
            ...tempObj,
            idCL: null
          };
        }

        if (
          searchingEmail &&
          searchingEmail?.data &&
          searchingEmail?.data?.dataMF[0] !== undefined
        ) {
          console.log('idMFVtex:..',searchingEmail?.data?.dataMF[0]?.id);
          tempObj = {
            ...tempObj,
            idMF: searchingEmail?.data?.dataMF[0]?.id,
          };
        }
        
        if(!tempObj.idMF||tempObj.idMF===undefined){
          tempObj = {
            ...tempObj,
            idMF: null
          };
        }

        console.log('tempObj:..',tempObj);
        if(tempObj){
          const {idAptos,idCL,idMF}=tempObj;
          if(idAptos&&idCL&&idMF){
            console.log('Usuario ya esta completamente registrado:...')
            setDataUser({
              ...dataUser,
              userExist:true,
              errorMessage:'El usuario ya esta completamente registrado',
              dataID: {...tempObj}
            })
            setSendingDataUser(false);
            setShowSpinner(false);
          }
          if(idAptos===null||idCL===null||idMF===null){
            
              console.log('Usuario puede continuar con su registro:...')
              console.log('idAptos:..',idAptos);
              console.log('idCL:..',idCL);
              console.log('idMF:..',idMF);
              
              sendDataForm();
            
            
          }
    
        }
        /* setDataUser({
          ...dataUser,
          dataID: {...tempObj},
        }); */
        return;
      }
    } catch (error) {
      console.log(error);
      return error;
    }
  };

  const sendDataForm = async () => {
    

    console.log('Comienza el proceso de registro:...');
    //searchForEmail();
    
    //return


    setDataUser({
      ...dataUser,
      succedRegister: true,
    });

    console.log("Enviando datos de usuario...", dataUser);
    console.log("Esperando respuesta del Backend...");
    let res = await newUserByFormAptosVetex(
      {
        ...dataUser,
        registerDomain: "internal",
        registerType: "express",
      }
    );
    console.log("respuesta del Backend:..", res);
    

    if(res){
      if(res.data){
        const {idAptos, idCL, idMF} = res.data;
        if(idAptos && idCL && idMF){
          setDataLocalStorage({});
        }else{
          setTimeout(()=>{
            setDataLocalStorage({...dataUser});
          },3000)
        }
      }
      if(!res.data){
        setTimeout(()=>{
          setDataLocalStorage({...dataUser});
        },3000)
        
      }
    }

    if (res.data) {
      let tempObj = {};
      if (res.data.message) {
        setDataUser({
          ...dataUser,
          errorMessage: res.data.message,
        });
      }
      if (res.data.isFounded) {
        tempObj = {
          ...tempObj,
          isFounded: res.data.isFounded || "",
        };
      }

      if (res.data.idAptos) {
        tempObj = {
          ...tempObj,
          idAptos: res.data.idAptos || "",
        };
      }
      if (res.data.idCL) {
        tempObj = {
          ...tempObj,
          idCL: res.data.idCL || "",
        };
      }
      if (res.data.idMF) {
        tempObj = {
          ...tempObj,
          idMF: res.data.idMF || "",
        };
      }

      //console.log("tempObj(dataRegister):", tempObj);
      
      if (tempObj.idAptos && tempObj.idCL && tempObj.idMF) {
        console.log("Registro de Cliente Exitoso...");
        setDataUser({
          ...dataUser,
          pageReload: true,
          registerComplete: true,
          dataID: tempObj,
        });
        setRegisterComplete(true);
        //navigate('/');
      }
      if (tempObj.idAptos && tempObj.idCL && !tempObj.idMF) {
        setDataUser({
          ...dataUser,
          pageReload: true,
          registerComplete: true,
          registerInComplete: 'Error en el objeto MF:..',
          dataID: tempObj,
        });
        console.log('Registro inCompleto error en idMF:..');
        setRegisterComplete(true);
      }
      if (tempObj.idAptos && !tempObj.idCL && tempObj.idMF) {
        setDataUser({
          ...dataUser,
          pageReload: true,
          registerComplete: true,
          registerInComplete: 'Error en el objeto CL:..',
          dataID: tempObj,
        });
        console.log('Registro inCompleto error en idCL:..');
        setRegisterComplete(true);
      }
      if (!tempObj.idAptos && tempObj.idCL && tempObj.idMF) {
        setDataUser({
          ...dataUser,
          pageReload: true,
          registerComplete: true,
          registerInComplete: 'Error en el idAptos:..',
          dataID: tempObj,
        });
        console.log('Registro inCompleto error en idAptos:..');
        setRegisterComplete(true);
      }
    }
  };

  return (
    <>
    
<div  className="ps-1 w-100">
      <Form>
        
        <Row className="cuponType">
          <Container className="w-100">
            <h2 className="text-primary fs-5">
              ¿Dónde quieres aplicar tu cupón de bienvenida?
              {!dataUser.cuponType && (
                <ErrorTooltip msg={'Favor de elegir'}/>
              )}
            </h2>
          </Container>
          <Col>
            <Form.Group className="mb-3" id="formGridPremises">
              <Form.Check
                value="store"
                name="cuponType"
                checked={cuponType === "store" ? true : false}
                onChange={handleChange}
                type="radio"
                label="Tienda Física"
              />
            </Form.Group>
          </Col>
          <Col>
            <Form.Group className="mb-3" id="formGridOnline">
              <Form.Check
                value="onLine"
                name="cuponType"
                checked={cuponType === "onLine" ? true : false}
                onChange={handleChange}
                type="radio"
                label="Tienda en Línea"
              />
            </Form.Group>
          </Col>
        </Row>
        
      </Form>
      
      
      {(!dataUser.isValidPaterno ||
        !dataUser.isValidEmail ||
        !dataUser.isValidNameUser ||
        !dataUser.cuponType) && (
        <h2 className="text-danger fs-6 text-center mt-4">
          *Es necesario completar correctamente los campos requeridos
        </h2>
      )}

      <Container className="w-100 d-flex justify-content-center">
        <Button
          onClick={searchForEmail}
          disabled={hideSendRegisterButton ? true : false}
          style={{
            border: "none",
            backgroundColor: "#ff000070",
            color: "#000",
          }}
          className="rojoHover w-100 mt-3 fw-bold"
        >
          {showSpinner ? (
            <Spinner animation="border" role="status">
              <span className="visually-hidden">Loading...</span>
            </Spinner>
          ) : (
            "Enviar Registro"
          )}
        </Button>
        {dataUser.errorMessage !== "" && (
          <h4 className="text-danger fs-6">{dataUser.errorMessage}</h4>
        )}
      </Container>
    </div>
  
    
    </>
  );
}

export default PreferenceExpress